import * as React from "react";
import { Link } from "react-router-dom";
import { CallToAction } from "./CallToAction";

export function ArtisanContent({ mobileOnly = false }) {
  return (
    <div
      className={`flex relative flex-col ${
        mobileOnly ? "items-center px-5" : "max-w-full w-[1121px]"
      } mb-0 max-md:mb-2.5 py-6`}
    >
      {!mobileOnly && (
        <div
          className="ml-5 text-center max-md:max-w-full"
          style={{ fontFamily: "'Sustainability', sans-serif", fontSize: "clamp(20px, 1.875vw, 30px)", lineHeight: "46px", fontWeight: 400 }}
        >
          FROM A KNIT COMMUNITY OF MONGOLIAN <br />
          ARTISANS TO YOU
        </div>
      )}

      <div
        className={`mt-8 md:mt-10 text-justify ${
          mobileOnly ? "text-black" : "text-white max-md:hidden"
        }`}
        style={{ fontFamily: "Sustainability, sans-serif", fontWeight: 300, fontSize: "clamp(12px, 0.9375vw, 18px)", lineHeight: "32px" }}
      >

        BODIOS, a distinguished family-owned Mongolian brand with 30 years
        of heritage, is now proudly led by its second generation. With
        privileged access to 60% of Mongolia's yak down, we meticulously
        oversee each step of the process to create an extraordinary
        softness—an embodiment of luxury at its finest.
        {/* <Link to="/about" className="self-stretch text-center my-auto hover:underline" style={{ fontFamily: "Sustainability, sans-serif", fontWeight: 400, fontSize: "20px", lineHeight: "32px" }}>Read more</Link> */}
      </div>

      {!mobileOnly && <CallToAction />}
    </div>
  );
}
